import React, { useEffect, useState } from 'react';

import Navbar from '../components/TopNav';
import Footer from '../components/Footer';
import Swal from 'sweetalert2';
import { BinanceSwapService } from '../services/BinanceSwapService';
import { BinanceMysteryBoxService } from '../services/BinanceMysteryBoxService';
import { getNetworkName } from '../utils';
import { checkIsWalletConnected, checkNetwork, toNumber } from '../web3Utils';
import { getContractAddress } from '../utils/abiHelper';
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';

const BinanceSwap = () => {
  

  const [nftList, setNftList] = useState([]);
  const [nftBalance, setNftBalance] = useState([]);
  
  const [isLoading, setIsLoading] = useState(false);
  const [isSwapInProgress, setIsSwapInProgress] = useState({});
  const [isApprovalInProgress, setIsApprovalInProgress] = useState({});
  const [needsApproval, setNeedsApproval] = useState({});
  const [isSwapInitialised, setIsSwapInitialised] = useState({});
  const [swapInitialisationInProgress, setSwapInitialisationInProgress] = useState({});

  const [transactionFee, setTransactionFee] = useState(0);
  const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [isCorrectNetwork, setIsCorrectNetwork] = useState(false);

  useEffect(()=> {
    init();
  },[]);

  const init = async () => {

    setIsLoading(true);
    checkIsWalletConnected().then((isConnected) => setIsWalletConnected(isConnected));
    checkNetwork().then((isNetworkId) => setIsCorrectNetwork(isNetworkId));

    try {
      const binanceMysteryBoxService = new BinanceMysteryBoxService();
      const binanceSwapService = new BinanceSwapService();

      const nftBalance = await binanceMysteryBoxService.balanceOf();
      const nfts = await binanceMysteryBoxService.getAll({});

      const contractInfo = await binanceSwapService.getContractInfo();

      setTransactionFee(toNumber(contractInfo.transactionFee, 4));
      setNftBalance( nftBalance );
      setNftList( nfts );
      setIsLoading(false);
    } catch(err) {
      console.log('err', err);
      setIsLoading(false);
    }
  }

  const loadMoreNfts = async () => {
    const binanceMysteryBoxService = new BinanceMysteryBoxService();
    const nfts = await binanceMysteryBoxService.getAll({ skip: nftList.length });
    setNftList([ ...nftList, ...nfts ]);
  }

  const handleSwapInit = async (swappableTokenId) => {
    if(!isWalletConnected) return toast.error('Please, Connect your Wallet.');
    if(!isCorrectNetwork) return toast.error('Incorrect Network.');

    const result = await Swal.fire({
      title: 'Please confirm to process the swap.',
      text: `A transaction fee of ${transactionFee} BNB will be deducted from your account to process the swap!`,
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: "#FF5917",
      showConfirmButton: true,
    })
    if(result.isDismissed) {
      return;
    }

    try {

      setSwapInitialisationInProgress({ [swappableTokenId]: true });
      const contractAddress = await getContractAddress('BinanceSwap');
      const binanceMysteryBoxService = new BinanceMysteryBoxService();
      const hasApproval = await binanceMysteryBoxService.isApprovedForAll( undefined, contractAddress );
      setNeedsApproval({ [swappableTokenId]: !hasApproval });
      setSwapInitialisationInProgress({ [swappableTokenId]: false });
      setIsSwapInitialised({ [swappableTokenId]: true });

    } catch (err) {
      setSwapInitialisationInProgress({ [swappableTokenId]: false });
      console.log('err', err);
      toast.error(err);
    }
  }

  const handleSwap = async (swappableTokenId) => {
    if(!isWalletConnected) return toast.error('Please, Connect your Wallet.');
    if(!isCorrectNetwork) return toast.error('Incorrect Network.');
    if(!swappableTokenId) return toast.error('Invalid Token Id.');

    const binanceSwapService = new BinanceSwapService();
    
    try {
      setIsSwapInProgress({ [swappableTokenId]: true });
      await binanceSwapService.swap({
        swappableTokenId
      });
      setIsSwapInProgress({ [swappableTokenId]: false });
      setIsSwapInitialised({ [swappableTokenId]: false });
      toast.success('Mystery Box NFT Swapped Successfully!');
    } catch(err) {
      console.log('err', err)
      toast.error(err);
      setIsSwapInProgress({ [swappableTokenId]: false });
    }
  }
  
  const handleApproval = async (swappableTokenId) => {
    if(!isWalletConnected) return toast.error('Please, Connect your Wallet.');
    if(!isCorrectNetwork) return toast.error('Incorrect Network.');

    const contractAddress = await getContractAddress('BinanceSwap');
    const binanceMysteryBoxService = new BinanceMysteryBoxService();
    try {
      setIsApprovalInProgress({ [swappableTokenId]: true });
      await binanceMysteryBoxService.setApprovalForAll(contractAddress);
      setNeedsApproval({ [swappableTokenId]: false });
      setIsApprovalInProgress({ [swappableTokenId]: false });
    } catch(err) {
      console.log('err', err)
      toast.error(err);
      setIsApprovalInProgress({ [swappableTokenId]: false });
    }
  }

  return (
    <div className="row no-gutters accumulation">
      <Navbar />
      <div className="col-12 main pb-5 inventory">
        <h5 className="title">Binance Mystery Boxes</h5>
          {
            isLoading ?
              <div className="my-5">
                Loading, please wait...
              </div>
            : !isWalletConnected ?
              <div className="my-5">
                Please, connect your <b>wallet</b> to show your NFTs here!
              </div>
            : !isCorrectNetwork ? 
              <div className="my-5">
                Switch to {getNetworkName(process.env.REACT_APP_MAIN_NETWORK_ID)} Network.
              </div>
            : 
              <>
                <div className="table-responsive" id="nft-inventory-list">
                  <InfiniteScroll
                      scrollableTarget="nft-inventory-list"
                      dataLength={nftList.length} //This is important field to render the next data
                      next={() => loadMoreNfts()}
                      hasMore={ nftList.length < nftBalance }
                      loader= {
                        <div className="w-50 mx-auto p-3 inventory-loader" tabIndex="0">
                          Loading...
                        </div>
                      }
                    >
                      <table className="table">
                        <thead>
                          <tr className="top-tr">
                            {/* <th>Name</th>
                            <th>Description</th> */}
                            <th>Token ID</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {nftList.map(nft=> (
                            <tr className={'tr'}>
                              {/* <td className={'td-left'}>
                                <div className="d-flex">
                                  <img width={40} height={40} src={nft.image} />
                                  <span className="ml-2">
                                    {nft.name} ({nft.tokenId})
                                  </span>
                                </div>
                              </td>
                              <td clas>{nft.description}</td> */}
                              <td className={'td-left text-center'}>
                                    {nft.tokenId}
                              </td>
                              <td className="td-right">
                                {
                                  needsApproval[nft.tokenId] ?
                                    <button disabled={isApprovalInProgress[nft.tokenId]} onClick={() => handleApproval(nft.tokenId)} className="btn upgrade">
                                      {
                                        isApprovalInProgress[nft.tokenId]
                                        ? 'Please Wait!'
                                        : 'APPROVE!'
                                      }
                                    </button>
                                  : isSwapInitialised[nft.tokenId] ?
                                    <button disabled={isSwapInProgress[nft.tokenId]} onClick={() => handleSwap(nft.tokenId)} className="btn upgrade">
                                      {
                                        isSwapInProgress[nft.tokenId]
                                        ? 'Please Wait!'
                                        : 'CONFIRM SWAP!'
                                      }
                                    </button> 
                                  :
                                    <button disabled={swapInitialisationInProgress[nft.tokenId]}  onClick={() => handleSwapInit(nft.tokenId)} className="btn upgrade">
                                      {
                                        swapInitialisationInProgress[nft.tokenId] 
                                        ? 'Please Wait!'
                                        : 'SWAP!'
                                      }
                                    </button>
                                }
                              </td>
                            </tr>
                          ))} 
                        </tbody>
                      </table>
                      <div className="mobile-view">
                        {nftList.map(nft => (
                          <div className={'sec-box box'}>
                            <div className="py-3">
                            {/* <p>{nft.name} ({nft.tokenId})</p>
                            <p>{nft.description}</p> */}
                            <p>{nft.tokenId}</p>
                            <p>
                              {
                                needsApproval[nft.tokenId] ?
                                  <button disabled={isApprovalInProgress[nft.tokenId]} onClick={() => handleApproval(nft.tokenId)} className="btn upgrade">
                                    {
                                      isApprovalInProgress[nft.tokenId]
                                      ? 'Please Wait!'
                                      : 'APPROVE!'
                                    }
                                  </button>
                                : isSwapInitialised[nft.tokenId] ?
                                  <button disabled={isSwapInProgress[nft.tokenId]} onClick={() => handleSwap(nft.tokenId)} className="btn upgrade">
                                    {
                                      isSwapInProgress[nft.tokenId]
                                      ? 'Please Wait!'
                                      : 'CONFIRM SWAP!'
                                    }
                                  </button> 
                                :
                                  <button disabled={swapInitialisationInProgress[nft.tokenId]}  onClick={() => handleSwapInit(nft.tokenId)} className="btn upgrade">
                                    {
                                      swapInitialisationInProgress[nft.tokenId] 
                                      ? 'Please Wait!'
                                      : 'SWAP!'
                                    }
                                  </button>
                                }
                            </p>
                          </div>
                          </div>
                        ))}
                      </div>
                  </InfiniteScroll>
                </div>
              </>
          }
      </div>
      <Footer />
     </div>
  )
}

export default BinanceSwap;